import authLinks from './authLinks';

export default authLinks;
